<template>
<div>
    <div class="box-header">
      <h3 class="box-title title">Productos Perecibles</h3>
    </div>

  <div class="box box-success">
    <div class="box-header title-boreder">
      <h3 class="box-title box-title-sub">
        <img class="icon-space" src='/static/img/icons/search.png' style="padding-bottom:7px"> Buscar Productos</h3>
    </div>

    <div class="box-body">
      <div class="filterContainer">
        <div class="row" style="padding-bottom:20px">
          <div class="col-md-4">
            <div id="divAccountSelect" class="form-group">
            <label>Cuenta</label>  
              <multiselect
                :value="this.selectedAccount"
                selectLabel=""
                selectedLabel=""
                deselectLabel=""
                track-by="name"
                :placeholder="this.selectedAccount.name"
                :allow-empty="false"
                label="name"
                :options="this.optionsAccount"
                @input="onAccountSelect">
              <span slot="noResult">No se encontraron resultados</span>
              </multiselect>
            </div>
          </div> 
        </div>

        <div class="row">
          <div class="col-md-2">
          <div class="form-group">  
            <label for="ddlLine">Línea</label>  
              <select id="ddlLine" v-model="selectedLine" class="form-control minimal">
              <option
                v-for="item in this.optionsLine"
                v-bind:key="item.code"
                v-bind:value="item.code"
              >{{ item.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-2 form-interspace ">
          <div class="form-group">  
            <label for="productCode">Producto</label>  
              <input id="productCode" v-model="productCode" type="text" class="form-control">
            <div
              v-show="submitted && productCode === ''"
              class="invalid-feedback"
            >Producto Requerido</div>
            </div>
          </div>
          <div class="col-md-2 form-interspace ">
          <div class="form-group">  
            <label for="ddlStatus">Estado</label>  
              <select id="ddlStatus" v-model="selectedStatus" class="form-control minimal">
              <option
                v-for="item in this.optionsStatus"
                v-bind:key="item.code"
                v-bind:value="item.code"
              >{{ item.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-2 form-interspace ">
          <div class="form-group">  
            <label for="ddlMode">Modo</label>  
              <select id="ddlMode" v-model="selectedMode" class="form-control minimal">
              <option
                v-for="item in this.optionsMode"
                v-bind:key="item.code"
                v-bind:value="item.code"
              >{{ item.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4 form-interspace ">
            <div class="form-group" style="padding-top:25px;">
            <button
	    	v-bind:class="['btn btn-success btnAction', { 'disabled' : (submitted && !productCode) }]" @click="search()"> Buscar</button>
	    </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="box-success">
    <div class="box-header title-boreder">
      <h3 class="box-title box-title-sub">
        <img class="icon-space" src='/static/img/icons/result.png' style="padding-bottom:4px"> Resultado de busqueda</h3>
    </div>
    
    <div class="box-body">
      <div class="row">
        <div class="col-md-12"  id="productsTable">
          <vuetable
            id="productsTable"
            ref="vuetable"
            :api-mode="false"
            :fields="tableFields"
            :css="tableCSS.table"
            :row-class="onRowClass"
            @vuetable:loading="onLoading"
            @vuetable:loaded="onLoaded"
            noDataTemplate="No se encontraron resultados"
            :data="tableData"
            :data-manager="dataManager"
            pagination-path="pagination"
            @vuetable:pagination-data="onPaginationData"
            :key="tableKey"
          >
           <template slot="productCode" scope="props">
                <div id="Código">
                  <span><strong>{{props.rowData.productCode}}</strong></span>
                </div>
            </template>
             <template slot="productDescription" scope="props">
                <div id="Descripción">
                  <span >{{props.rowData.productDescription}}</span>
                </div>
            </template>
             <template slot="productUnits" scope="props">
                <div id="Cantidad">
                  <span >{{props.rowData.productUnits}}</span>
                </div>
            </template>
             <template slot="productStatus" scope="props">
                <div id="Estado">
                  <span >{{props.rowData.productStatus}}</span>
                </div>
            </template>
             <template slot="productLot" scope="props">
                <div id="Lote">
                  <span >{{props.rowData.productLot}}</span>
                </div>
            </template>
            <template slot="productExpireDate" scope="props">
                <div id="FechaExp">
                  <span >{{props.rowData.productExpireDate | formatDate("DD/MM/YYYY")}}</span>
                </div>
            </template>
            <template slot="productLine" scope="props">
                <div id="Lìnea">
                  <span >{{props.rowData.productLine}}</span>
                </div>
            </template>
            <template slot="productModeCode" scope="props">
                <div id="Modo">
                  <span >{{props.rowData.productModeCode}}</span>
                </div>
            </template>

          </vuetable>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          &nbsp;
          <template v-if="this.paginationData && paginationData.total > 0">
            <strong>
            Mostrando producto {{ this.paginationData.from }} a {{ this.paginationData.to }} de {{ this.paginationData.total }} en Total
            </strong>
          </template>
        </div>
        <div class="col-md-6">
          <vuetable-pagination ref="pagination"
            :css="tableCSS.pagination"
            @vuetable-pagination:change-page="onChangePage"
          ></vuetable-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { Vuetable, VuetablePagination } from 'vuetable-2'
import moment from 'moment/moment.js'
import constants from 'assets/js/constants.js'

export default {
  name: 'PerishableProducts',
  components: {
    Multiselect,
    Vuetable,
    'vuetable-pagination': VuetablePagination
  },
  data () {
    return {
      loader: null,
      submitted: false,
      selectedAccount: null,
      optionsLine: [],
      selectedLine: null,
      productCode: null,
      optionsStatus: [],
      selectedStatus: null,
      optionsMode: [],
      selectedMode: null,
      tableKey: 1,
      tableData: null,
      tableFields: [
        {
          name: '__slot:productCode',
          title: 'Código',
          callback: 'formatCode'
        },
        {
          name: '__slot:productDescription',
          title: 'Descripción'
        },
        {
          name: '__slot:productUnits',
          title: 'Cantidad'
        },
        {
          name: '__slot:productStatus',
          title: 'Estado'
        },
        {
          name: '__slot:productLot',
          title: 'Lote'
        },
        {
          name: '__slot:productLine',
          title: 'Línea'
        },
        {
          name: '__slot:productModeCode',
          title: 'Modo',
          callback: 'formatModeCode'
        },
        {
          name: '__slot:productExpireDate',
          title: 'Fecha Exp',
          callback: 'formatDate'
        }
      ],
      tableCSS: null,
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      paginationData: null
    }
  },
  computed: {
    ...mapGetters(['userClients'])
  },
  created () {
    this.tableCSS = constants.tableCSS
    this.loadSelectData()
  },
  methods: {
    ...mapActions([
      'fetchInventoryLines',
      'fetchInventoryStatus',
      'fetchPerishableProductsModes',
      'fetchPerishableProductsList'
    ]),
    loadSelectData () {
      // Account
      this.optionsAccount = Array.from(this.userClients)
      this.selectedAccount = this.optionsAccount[0]

      // Status
      this.loadStatusOptions()

      // Mode
      this.optionsMode = []

      this.fetchPerishableProductsModes().then(data => {
        if (data != null) {
          this.optionsMode = data.map(item => ({
            code: item.code,
            name: item.text
          }))

          if (this.optionsLine.length === 0) {
            this.optionsLine.push(constants.defaultSelectItem)
          }

          this.selectedMode = this.optionsMode[0].code
        }
      })

      // Line
      this.loadLineOptions()
    },
    search () {
      document.activeElement.blur()

      let params = {
        ClientCode: this.selectedAccount.code,
        Line: this.selectedLine === 'All' ? '' : this.selectedLine,
        ItemCode: this.productCode,
        Status: this.selectedStatus === 'All' ? '' : this.selectedStatus,
        ExpirationMode: this.selectedMode === 'All' ? '' : this.selectedMode
      }

      this.loader = this.$loading.show({
        loader: 'dots'
      })
      this.fetchPerishableProductsList(params).then(data => {
        if (data != null) {
          let formattedData = data.map(item => ({
            accountCode: item.clientCode,
            productCode: item.productCode,
            productDescription: item.productDescription,
            productUnits: item.quantity,
            productStatus: item.status,
            productLot: item.batch,
            productExpireDate: item.expiration,
            productLine: item.line,
            productModeCode: item.expirationStatus
          }))

          this.tableData = {
            data: formattedData
          }
          this.tableKey++
          this.loader.hide()
        }
      })
    },
    loadLineOptions () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })

      this.optionsLine = []
      this.fetchInventoryLines(this.selectedAccount.code).then(data => {
        if (data != null) {
          this.optionsLine = data.map(item => ({
            code: item.code,
            name: item.line
          }))

          this.optionsLine.unshift(constants.defaultSelectItem)

          this.selectedLine = this.optionsLine[0].code
          $('.vld-overlay').remove()
        }
      })
    },
    loadStatusOptions () {
      this.optionsStatus = []

      this.fetchInventoryStatus(this.selectedAccount.code).then(data => {
        if (data != null) {
          this.optionsStatus = data.map(item => ({
            code: item.code,
            name: item.text
          }))

          this.optionsStatus.unshift(constants.defaultSelectItem)

          this.selectedStatus = this.optionsStatus[0].code
        }
      })
    },
    /* DropDownList Events */
    onAccountSelect (account) {
      this.selectedAccount = account
      this.loadLineOptions()
      this.loadStatusOptions()
    },
    /* Table Events */
    onLoading () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })
    },
    onLoaded () {
      this.loader.hide()
    },
    formatClient (value) {
      let formattedVal = this.optionsAccount.filter(item => item.code === value)
      return formattedVal.length > 0 ? formattedVal[0].name : ''
    },
    formatStatus (value) {
      let formattedVal = this.optionsStatus.filter(item => item.code === value)
      return formattedVal.length > 0 ? formattedVal[0].name : ''
    },
    formatDate (value) {
      return moment(value).format('DD/MM/YYYY')
    },
    formatAmount (value) {
      return this.$options.filters.formatPercentage(value) + '%'
    },
    /* Table Pagination */
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.paginationData = paginationData
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    dataManager (sortOrder, pagination) {
      let data = []

      if (this.tableData) {
        data = this.tableData.data

        pagination = this.$refs.vuetable.makePagination(data.length)
        data = data.slice(pagination.from - 1, pagination.to)
      } else {
        pagination = this.$refs.vuetable.makePagination(0)
      }

      return {
        pagination: pagination,
        data: data
      }
    },
    formatCode (value) {
      return '<strong>' + value + '</strong>'
    },
    formatModeCode (value) {
      return '<span class="label">' + value + '</span>'
    },
    onRowClass (dataItem, index) {
      switch (dataItem.productModeCode) {
        case 'Por vencer':
          return 'expiring'
        case 'Vencido':
          return 'expired'
        default:
          return ''
      }
    }
  },
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }
  }
}
</script>

<style>

/* #productsTable th {

} */

#FechaExp{
  text-align: center !important;
  border-radius:5px;
  width:80px;
}

#productsTable tr.expiring #FechaExp {
  background-color: #f39c12 !important;
  color: #ffffff;
}

#productsTable tr.expired #FechaExp {
  background-color: #dd4b39 !important;
  color: #ffffff;
}

#divAccountSelect,
#divSearchSelect {
  height: 34px;
}

#divAccountSelect.multiselect__tags,
#divSearchSelect .multiselect__tags {
  border-radius: 0px !important;
  min-height: 34px;
  height: 34px;
}

#divAccountSelect .multiselect__select {
  border-radius: 0px !important;
  height: 34px;
}

.productCode {
  background-color: #808000;
  color: #FFF;
  border: white 1px solid;
  padding: 2px 5px;
  font-weight: bold;
}

@media screen and (max-width: 900px) {

  #documentTypeCode td{
    padding-left: 50%  !important
  }

  #FechaExp{
  text-align: right !important;
  border-radius:5px;
  width:100% !important;
}

#productsTable tr.expiring #FechaExp {
  background-color: white !important;
  color: black;
}

#productsTable tr.expired #FechaExp {
  background-color: white !important;
  color: black;
}

#productsTable tr.expiring #FechaExp>span {
  background-color: #f39c12 !important;
  color: #ffffff;
}

#productsTable tr.expired #FechaExp>span {
  background-color: #dd4b39 !important;
  color: #ffffff;
}
#FechaExp>span{
  text-align: center !important;
  border-radius:3px;
}


#productsTable tr.expired #Modo >span
   #productsTable table {
      border-radius:5px;
    }

   #productsTable table thead {
      display: none;
    }

   #productsTable table tr {
      margin-top: 10px;
      margin-bottom: 20px;
      display: block;
      border:  3px solid;
      border-color:#F2F4F6;
      background-color: white !important;
    }

   #productsTable table td {
      display: block;
      border: none !important;
      font-size: 11px;
      text-align: right;
      padding: 3px;
      padding-right: 8px;
      padding-left: 8px;
    }

   #productsTable table td:last-child {
      border-bottom: 0;
    }

    #productsTable table td div::before{
      content: attr(id);
      float: left;
      text-transform: uppercase;
      font-weight: bold;
    }
    	#productsTable	tbody{
			line-height:0!important;
		}

    .table-btn {
    float: none !important;
    background: none !important;
}

  }

</style>



// WEBPACK FOOTER //
// PerishableProducts.vue?37015f55